// @flow

import { type Address } from '@tectonics/prs/address';
import cepPromise from 'cep-promise';

export async function searchBrazilianZipcode(zipcode: string): Promise<Address> {
  const providersList = getProvidersList();

  for (let i = 0; i < providersList.length; i++) {
    const provider = providersList[i];
    try {
      return await Promise.race([timeout(2000), provider(zipcode)]);
    } catch {
      continue;
    }
  }
  return searchFailedResponse(zipcode);
}

const timeout = (delay) => new Promise((_, reject) => setTimeout(reject, delay));

function getProvidersList(): Array<any> {
  if(ENV_CONSTANTS.ENV === 'test') {
    return [];
  }
  return [payCepProvider, cepPromiseProvider];
}

async function payCepProvider(zipcode): Promise<Address> {
  const response = await fetch(`https://api.ebanxpay.com/util/cep?cep=${zipcode}`);
  const result = await response.json();

  return {
    zipcode,
    country: 'br',
    state: result.uf,
    city: result.cidade,
    street_name: result.logradouro,
    street_number: '',
    street_complement: '',
  };
}

async function cepPromiseProvider(zipcode): Promise<Address> {
  const result = await cepPromise(zipcode);

  return {
    zipcode,
    country: 'br',
    state: result.state,
    city: result.city,
    street_name: result.street,
    street_number: '',
    street_complement: '',
  };
}

function searchFailedResponse(zipcode): Address {
  return {
    country: 'br',
    zipcode,
    state: '',
    city: '',
    street_name: '',
    street_number: '',
    street_complement: '',
  };
}
